import * as helper from './../../../Assets/Js/helper';

export function Menu() {
	const links = helper.$('.navmobile-list a, .sticky .nav li a');

	function clearActive() {
		for (const link of links) {
			helper.removeClass(link, 'active');
		}
	}

	for (const link of links) {
		helper.addClickListener(link, (e: MouseEvent) => {
			e.preventDefault();
			const anchor = link.href.split('#')[1];
			const element = document.querySelector('#' + anchor);
			const offset = element.getBoundingClientRect();
			clearActive();
			helper.addClass(link, 'active');

			window.scrollTo({ left: 0, top: offset.y + window.pageYOffset - 120, behavior: "smooth" });
		})
	}
}
